import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { CampaignBookRoutes } from './book';
import CampaignDashboard from './dashboard';
import { CampaignManage } from './manage';
import { CampaignMeasure } from './measure';
import { CampaignMessages } from './messages';
import { CampaignOptions } from './options';
import { hasAccessRights } from '../../../shared/functions/Functions';
import { AccessRightEnum } from '../../../enum/AccessRightEnum';
import CampaignContractsRoutes from './contracts';
import LongTermDashboard from './long-term-dashboard';
import { shallowEqual, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { CampaignDiscoveryRoutes } from './discovery';

export function CampaignRoutes() {
    const { isAclLoaded } = useSelector((state: IAllStates) => state.selectedCampaign, shallowEqual);

    return isAclLoaded ? (
        <>
            {/*<ErrorBoundary key={pathname}>*/}
            <Routes>
                {hasAccessRights(AccessRightEnum.CAN_VIEW_DASHBOARD) ? (
                    <Route
                        path="dashboard/:id"
                        element={
                            hasAccessRights(AccessRightEnum.CAN_VIEW_DASHBOARD) ? (
                                <CampaignDashboard />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />
                ) : (
                    <Route
                        path="dashboard/:id"
                        element={
                            hasAccessRights(AccessRightEnum.CAN_VIEW_LONG_DASHBOARD) ? (
                                <LongTermDashboard />
                            ) : (
                                <Navigate to="/" />
                            )
                        }
                    />
                )}
                <Route
                    path="discovery/*"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_DISCOVERY) ? (
                            <CampaignDiscoveryRoutes />
                        ) : (
                            <Navigate to="/" />
                        )
                    }
                />
                <Route
                    path="book/*"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_BOOKING) ? <CampaignBookRoutes /> : <Navigate to="/" />
                    }
                />
                <Route
                    path="contracts/*"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_CONTRACTS) ? (
                            <CampaignContractsRoutes />
                        ) : (
                            <Navigate to="/" />
                        )
                    }
                />
                <Route
                    path="options/:id"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_OPTIONS) ? <CampaignOptions /> : <Navigate to="/" />
                    }
                />
                <Route
                    path="measure/:id"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_MEASURE) ? <CampaignMeasure /> : <Navigate to="/" />
                    }
                />
                <Route
                    path="manage/:id"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_MESSAGE) ? <CampaignManage /> : <Navigate to="/" />
                    }
                />
                <Route
                    path="messages/:id/"
                    element={
                        hasAccessRights(AccessRightEnum.CAN_VIEW_MESSAGE) ? <CampaignMessages /> : <Navigate to="/" />
                    }
                />
            </Routes>
            {/*</ErrorBoundary>*/}
        </>
    ) : null;
}
